import type { UseMutationResult } from '@tanstack/react-query';
import {
  useBarcodeLookup,
  useReceiveVariantStock,
  type BarcodeLookupResult,
  type BarcodeStockUpdateInput,
  type BarcodeStockUpdateResult,
} from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useAdminBarcodeLookup(
  storeId: string | null,
): UseMutationResult<
  BarcodeLookupResult,
  unknown,
  { rawBarcode: string; requestId: number; signal?: AbortSignal }
> {
  return useBarcodeLookup(supabase, storeId);
}

export function useAdminReceiveVariantStock(): UseMutationResult<
  BarcodeStockUpdateResult,
  unknown,
  BarcodeStockUpdateInput
> {
  return useReceiveVariantStock(supabase);
}
